import Api from './Api'

export default class Basic extends Api {}
